import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import useUpdateMode from '@hooks/useUpdateMode'
import { saveAnswer } from '@utils/onboardingStorage'
import { useTranslation } from 'react-i18next'
import { useSearchParams, useSubmit } from 'react-router-dom'

const QUESTION_KEY = 'feelings'

const OPTIONS = [
  {
    value: 'Overwhelmed',
    translationKey: 'pages.onboarding.feelings.options.overwhelmed',
  },
  {
    value: 'Indifferent',
    translationKey: 'pages.onboarding.feelings.options.indifferent',
  },
  {
    value: 'Stuck',
    translationKey: 'pages.onboarding.feelings.options.stuck',
  },
  {
    value: 'Sentimental',
    translationKey: 'pages.onboarding.feelings.options.sentimental',
  },
  {
    value: 'Curious',
    translationKey: 'pages.onboarding.feelings.options.curious',
  },
  {
    value: 'Peaceful',
    translationKey: 'pages.onboarding.feelings.options.peaceful',
  },
]

export default function FeelingsPage() {
  const submit = useSubmit()
  const { t } = useTranslation()
  const [searchParams] = useSearchParams()
  const value = searchParams.get('value')
  const preselectedValue =
    value && OPTIONS.some((option) => option.value === value)
      ? value
      : undefined
  const { isUpdate, postToReactNative } = useUpdateMode()

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    // Get the answer value from the form
    const formData = new FormData(event.currentTarget)
    const value = formData.get('answer') as string

    if (!value) return

    const answer = {
      question_key: QUESTION_KEY,
      question: 'How does this space make you feel right now?',
      answer_key: value,
      answer: value,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(event.currentTarget)
    }
  }

  // Transform options to the format expected by QuestionPage
  const buttons = OPTIONS.map((option) => ({
    text: t(option.translationKey),
    value: option.value,
  }))

  return (
    <QuestionPage
      heading={t('pages.onboarding.feelings.heading')}
      buttons={buttons}
      onSubmit={handleSubmit}
      headingSize="text-3xl text-center whitespace-pre-line"
      buttonTextSize="text-xl"
      buttonBgColor="bg-white"
      preselectedValue={preselectedValue}
    />
  )
}
